// --- Hover Dropdown for Dawn 15.4.0 ---
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth >= 990) {
    // Handle first-level dropdowns
    document.querySelectorAll('nav.header__inline-menu > ul > li header-menu > details').forEach((detail) => {
      const summary = detail.querySelector('summary');
      if (!summary) return;

      // Prevent click toggle on desktop
      summary.addEventListener('click', e => e.preventDefault());

      detail.addEventListener('mouseenter', () => {
        detail.setAttribute('open', true);
      });
      detail.addEventListener('mouseleave', () => {
        detail.removeAttribute('open');
      });
    });

    // Handle nested (child) submenus
    document.querySelectorAll("details[id^='Details-HeaderSubMenu-']").forEach((sub) => {
      const summary = sub.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', e => e.preventDefault());

      sub.addEventListener('mouseenter', () => {
        sub.setAttribute('open', true);
      });
      sub.addEventListener('mouseleave', () => {
        sub.removeAttribute('open');
      });
    });
  }
});
